import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { useAuth } from '../auth.jsx';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [form, setForm] = useState({ email: '', name: '', password: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      navigate('/purchase-orders', { replace: true });
    } catch (err) {
      toast.error(err.message || t('register.failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center px-4">
      <form onSubmit={submit} className="card w-full max-w-sm p-6 space-y-4">
        <div className="text-center">
          <div className="text-xl font-semibold tracking-tight">mpo</div>
          <div className="text-xs text-zinc-500 mt-1">{t('register.subtitle')}</div>
        </div>
        <div>
          <label className="label">{t('register.name')}</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input" />
        </div>
        <div>
          <label className="label">{t('register.email')}</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input" autoComplete="email" />
        </div>
        <div>
          <label className="label">{t('register.password')}</label>
          <input type="password" required minLength={12} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input" autoComplete="new-password" />
          <p className="text-[11px] text-zinc-600 mt-1">{t('register.passwordHint')}</p>
        </div>
        <button type="submit" disabled={busy} className="btn-primary w-full">
          {busy ? t('register.creating') : t('register.create')}
        </button>
        <div className="text-center text-xs text-zinc-500">
          <Link to="/login" className="hover:text-zinc-300">{t('register.haveAccount')}</Link>
        </div>
      </form>
    </div>
  );
}
